import { render, staticRenderFns } from "./RRRequirements.vue?vue&type=template&id=570d80a8&scoped=true&"
import script from "./RRRequirements.vue?vue&type=script&lang=js&"
export * from "./RRRequirements.vue?vue&type=script&lang=js&"
import style0 from "./RRRequirements.vue?vue&type=style&index=0&id=570d80a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d80a8",
  null
  
)

export default component.exports